<ion-grid class="ComparablesTable">
  <!-- Header Row -->
  <ion-row class="header-row">
    @for (column of columnsToDisplay; track column) {
      <ion-col
        [ngClass]="{
          'CompsTable__Column--Right': alignRight(column),
          'CompsTable__Column--OverflowVisible': column === 'salesStatus'
        }"
        class="ComparablesTable__HeaderRow {{
          'CompsTable__Column--' + column
        }}"
        (click)="handleColumnSort(column)"
        [size]="isBigColumn(column)"
      >
        @if (column === 'salesStatus') {
          @if (showStatusHeader) {
            <span>{{ headerLookup[column] }}&nbsp;</span>
          }
          <smartflip-status-legend></smartflip-status-legend>
        } @else {
          <span [innerHTML]="headerLookup[column]"></span>&nbsp;
          @if (
            sortState.active === column && sortState.active !== 'selectBox'
          ) {
            <ion-icon
              class="CompsTable__SortIcon CompsTable__SortIcon{{
                getColumnSort(column)
              }}"
              name="chevron-down-outline"
            ></ion-icon>
          }
        }
      </ion-col>
    }
  </ion-row>

  <!-- Data Rows -->
  @for (property of compsTableSource; track property; let index = $index) {
    <ion-row
      class="data-row"
      [class.expandedRow]="expandedElement === property"
      [class.SummaryRow--Highlighted]="property?.street === highlightedAddress"
      (click)="expandedElement = expandedElement === property ? null : property"
      (mouseenter)="onHoverChange(property)"
      (mouseleave)="onHoverChange(null)"
    >
      @for (column of columnsToDisplay; track column) {
        <ion-col
          [ngClass]="{ 'CompsTable__Column--Right': alignRight(column) }"
          [size]="isBigColumn(column)"
        >
          @if (column !== 'selectBox') {
            @if (column === 'salesStatus') {
              <ion-icon [name]="getIonicIcon(property[column])"></ion-icon>
            } @else {
              <span [innerHTML]="formatColumnData(column, property)"></span>
            }
          } @else {
            <ion-checkbox
              (click)="$event.stopPropagation()"
              (ionChange)="
                $event.detail.checked
                  ? compSelection.toggle(property)
                  : compSelection.deselect(property)
              "
              [checked]="compSelection.isSelected(property)"
            ></ion-checkbox>
          }
        </ion-col>
      }
    </ion-row>

    <!-- Expanded Detail Row -->
    @if (expandedElement === property) {
      <ion-row class="detail-row">
        <ion-col [size]="6" [sizeMd]="11">
          <div class="ComparablesTable__Detail">
            <div class="CompsTable__Address">
              <div>
                <span class="ComparablesTable__FullAddress">
                  {{ property.city }}, {{ property.state }}
                  {{ property.zipcode }} </span
                ><br />
                @if (!showStatusHeader) {
                  <span><b>Distance:&nbsp;</b></span>
                  <span [innerHTML]="property.distanceFromSource"></span
                  >mi<br />
                  <span><b>Bedrooms:&nbsp;</b></span>
                  <span [innerHTML]="property.bedrooms"></span>mi<br />
                }
                <span><b>Type:&nbsp;</b></span
                ><span [innerHTML]="property.propertyType"></span>
              </div>
            </div>
            <!-- Right Column -->
            <div class="CompsTable__MetaStack">
              <div class="CompsTable__Meta">
                <h6>Last Date Sold:&nbsp;</h6>
                <span [innerHTML]="property.lastSoldDate | date"></span>
              </div>
              <div class="CompsTable__Meta">
                <h6>Year Built:&nbsp;</h6>
                <span [innerHTML]="property.yearBuilt"></span>
              </div>
              <div class="CompsTable__Meta">
                <h6>Lot Size:&nbsp;</h6>
                <span [innerHTML]="property.lotSize"></span>
              </div>
              @if (!showStatusHeader) {
                <div class="CompsTable__Meta">
                  <h6>Square Ft:&nbsp;</h6>
                  <span [innerHTML]="property.finishedSqFt"></span>
                </div>
                <div class="CompsTable__Meta">
                  <h6>Last Sold Price:&nbsp;</h6>
                  <span [innerHTML]="property.lastSoldPrice"></span>
                </div>
              }
            </div>
          </div>
        </ion-col>
      </ion-row>
    }
  }
</ion-grid>
